import CompanyEditor from './company-editor';

export default CompanyEditor;
